import React, { Component, useEffect } from "react";
import Image from '../global/Image';
import VisibilitySensor from 'react-visibility-sensor';

export default class PageTimeline extends Component {
	
	constructor(){
		super()
		this.state = {
			started:false,
		}
		this.startAnimation = this.startAnimation.bind(this);
	}
	
	startAnimation = (isVisible) => {
		if (this.state.started === false && isVisible === true) {
			this.setState({started : true});
			document.getElementsByClassName('c-timeline__inner')[0].scrollTo({
				left: 		(document.getElementsByClassName('c-timeline')[0].clientWidth * 0.25),
				behavior: 	'smooth',
			});
		}
    }
    		
	render () {
		
		let block = this.props.block;
		let k = 0;
				
		if (block) {
	         
		    return (
		        <div data-id={block.id} className={'c-page__block c-page__space c-page__space--' + block.spacing_before }>
		        	
		        	<div className="c-timeline scope-reverse">
		        	
		        		{block.srcset &&
							<div className="c-timeline__background">
								<Image srcset={block.srcset} src={block.src}></Image>
							</div>
						}
		        	
		        		<div className="c-timeline__inner">
		        			
		        			<div className="c-timeline__content">
		        				
		        				<div className="c-timeline__header">
		        					<VisibilitySensor onChange={this.startAnimation}>
		        						<h4 className="c-timeline__header__heading" dangerouslySetInnerHTML={{__html:block.start_year + '<span></span>' + block.end_year}}></h4>
		        					</VisibilitySensor>
		        				</div>
		        				
		        				<div className="c-timeline__years">
		        					
		        					{block.cells.map((cell,i) =>
										{	
											if (i % 2 === 0) {
												return (
													<div className="c-timeline__year" key={i}>
														<div className="c-timeline__year__top">
															{cell.srcset &&
																<div className="c-timeline__year__image">
																	<Image srcset={cell.srcset} src={cell.src}></Image>
																</div>
															}
														</div>
														<div className="c-timeline__year__bottom">
															<div className="c-timeline__year__text">
																{cell.year &&
																	<div className="c-timeline__year__text__heading" dangerouslySetInnerHTML={{__html:cell.year}}></div>
																}
																{cell.text &&
																	<div className="scope-text" dangerouslySetInnerHTML={{__html:cell.text}}></div>
																}
															</div>
														</div>
													</div>
												)
											} else {
												return (
													<div className="c-timeline__year" key={i}>
														<div className="c-timeline__year__top">
															<div className="c-timeline__year__text">
																{cell.year &&
																	<div className="c-timeline__year__text__heading" dangerouslySetInnerHTML={{__html:cell.year}}></div>
																}
																{cell.text &&
																	<div className="scope-text" dangerouslySetInnerHTML={{__html:cell.text}}></div>
																}
															</div>
														</div>
														<div className="c-timeline__year__bottom">
															{cell.srcset &&
																<div className="c-timeline__year__image">
																	<Image srcset={cell.srcset} src={cell.src}></Image>
																</div>
															}
														</div>
													</div>
												)
											}
										}
									)}
		        					
		        				</div>
		        			
		        			</div>
		        		
		        		</div>
		        		
		        		<p className="c-timeline__scroll-prompt">Scroll</p>
		        	
		        	</div>
		        
				</div>
			)
			
		} else {
			
			return null;
		
		}
	}
}
